import { render, staticRenderFns } from "./SidebarLarge.vue?vue&type=template&id=5dc3a18c&"
import script from "./SidebarLarge.vue?vue&type=script&lang=js&"
export * from "./SidebarLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports